import {createAsyncThunk} from '@reduxjs/toolkit';
import {hideSpinner, showSpinner} from '../../slices/screenSlice';
import {AppDispatch, RootState} from '../../store';
import Util from 'src/Util';
import {PlatformApiErrors} from 'src/api/PlatformApi';
import {alertError} from 'src/components/helpers/AlertHelper';
import Localized from 'src/constants/AppStrings';
import Events from 'src/logging/Events';
import {generateErrorMessage} from 'src/logging/generateErrorMessage';
import PlatformApi from 'src/api/PlatformApi';
import HttpClient from 'src/api/HttpClient';
import Logger from 'src/logging/Logger';
import CrashlyticsEvents from 'src/logging/Crashlytics';
import {Snack} from 'src/types/snack/Snack';

export type BlockUserParams = {
  snackDetails: Snack;
};
export const blockUser = createAsyncThunk<
  Snack,
  BlockUserParams,
  {dispatch: AppDispatch; state: RootState}
>('snack/blockUser', async ({snackDetails}, {dispatch, getState}) => {
  dispatch(showSpinner({}));
  const accountId = getState().account.account.id;
  let blockSnackUserRes;
  try {
    blockSnackUserRes = await PlatformApi.blockSnackUser(
      accountId,
      snackDetails.senderAccountId,
      Util.getCurrentDate(),
    );

    Logger.Log.LogAPIEvent(
      'PlatformAPI',
      'BlockSnackUser',
      JSON.stringify({
        accountId,
        senderAccountId: snackDetails.senderAccountId,
      }),
      JSON.stringify(blockSnackUserRes),
    );

    return {
      ...snackDetails,
      isBlocked: true,
      blockedAccountId: snackDetails.senderAccountId,
    };
  } catch (err) {
    const error = HttpClient.parseJsonSafe(err?.message ?? err.toString());

    if (error?.code === PlatformApiErrors.SnackUserBlocked) {
      alertError(Localized.Errors.snack_user_already_blocked);
    } else {
      alertError(Localized.Errors.error);
      CrashlyticsEvents.log(
        'Exception',
        'snack/blockUser',
        generateErrorMessage(error),
      );
      Events.Error.trackEvent(
        'Exception',
        'snack/blockUser',
        generateErrorMessage(error),
        blockSnackUserRes,
      );
    }
    Logger.Log.LogAPIEvent(
      'PlatformAPI',
      'BlockSnackUser',
      JSON.stringify({
        accountId,
        senderAccountId: snackDetails.senderAccountId,
      }),
      JSON.stringify(err),
    );
  } finally {
    dispatch(hideSpinner());
  }
});
